/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'number',
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    number_of_diverse_workers_on_parental_leave: valueSchema,
  },
}
